import type { IconComponent } from "@once-ui-system/core";
import { FaGoogle, FaMicrosoft } from "react-icons/fa6";
import {
  HiOutlineBackspace,
  HiOutlineChatBubbleLeftRight,
  HiOutlineClock,
  HiOutlineMicrophone,
  HiOutlinePhone,
  HiOutlinePhoneArrowDownLeft,
  HiOutlinePhoneArrowUpRight,
  HiOutlinePhoneXMark,
  HiOutlineQueueList,
  HiOutlineSignal,
  HiOutlineSignalSlash,
} from "react-icons/hi2";

// Icons missing from Once UI's built-in set; registered here and typed below.
export const extraIcons = {
  google: FaGoogle,
  microsoft: FaMicrosoft,
  phone: HiOutlinePhone,
  phoneIncoming: HiOutlinePhoneArrowDownLeft,
  phoneOutgoing: HiOutlinePhoneArrowUpRight,
  phoneHangup: HiOutlinePhoneXMark,
  microphone: HiOutlineMicrophone,
  signal: HiOutlineSignal,
  signalOff: HiOutlineSignalSlash,
  clock: HiOutlineClock,
  backspace: HiOutlineBackspace,
  transcript: HiOutlineChatBubbleLeftRight,
  history: HiOutlineQueueList,
} satisfies Record<string, IconComponent>;

declare module "@once-ui-system/core" {
  interface IconLibraryOverrides {
    google: true;
    microsoft: true;
    phone: true;
    phoneIncoming: true;
    phoneOutgoing: true;
    phoneHangup: true;
    microphone: true;
    signal: true;
    signalOff: true;
    clock: true;
    backspace: true;
    transcript: true;
    history: true;
  }
}
